import { render, staticRenderFns } from "./AddEditCertification.vue?vue&type=template&id=370ec383&v-if=allowEdit"
import script from "./AddEditCertification.vue?vue&type=script&lang=js"
export * from "./AddEditCertification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports